import {
  FilterMode,
  EvaluationQueryCreateMutationVariables,
  EvaluationQuery_OrderBy,
  EvaluationQuery,
  SortOrder,
  EvaluationQuery_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const evaluationQueryService = {
  createOne: buildCreateOne(
    (evaluationQueryCreateVariables: EvaluationQueryCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.evaluationQueryCreate(
          evaluationQueryCreateVariables
        );
        return result.evaluationQueryCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.evaluationQueryOne({ id });
    return result.evaluationQueryOne as EvaluationQuery;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EvaluationQuery_OrderBy[] | null = null,
    filter: EvaluationQuery_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EvaluationQuery_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { query: { contains: searchValue, mode: FilterMode.Insensitive } },
          {
            expectedTool: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.evaluationQueryListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ query: SortOrder.Asc }, { expectedTool: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.evaluationQueryListWithOffset
    ) as EvaluationQuery[];
    return { list, orderBy };
  },
};
